import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Container, Grid, Cell } from 'components/Grid';
import Image from 'components/ImageV2';
import { Small, MediumUp } from 'components/MediaQuery';
import RichText from 'components/RichText';
import { IMAGE_WIDTHS } from 'constants/images';
import { smallUp, largeUp } from 'constants/mediaQueries';

const SustainabilityPageCopy = ({ data }) => {
  const { text, imageDesktop, imageMobile } = data;

  const imageDesktopDimensions = {
    height: get(imageDesktop, ['file', 'details', 'image', 'height']),
    width: get(imageDesktop, ['file', 'details', 'image', 'width']),
  };

  const imageMobileDimensions = {
    height: get(imageMobile, ['file', 'details', 'image', 'height']),
    width: get(imageMobile, ['file', 'details', 'image', 'width']),
  };

  const hasMobileImage = !isEmpty(imageMobile);
  const hasDesktopImage = !isEmpty(imageDesktop);

  return (
    <div className="SustainabilityPageCopy">
      <Container>
        <Grid className="SustainabilityPageCopy__grid">
          <Cell smallUp={{ columns: 12 }} mediumUp={{ columns: 11 }} largeUp={{ columns: 10 }}>
            <RichText content={text} />
            {hasMobileImage && (
              <Small>
                <Image
                  src={get(imageMobile, ['file', 'url'])}
                  alt={get(imageMobile, 'title')}
                  width={IMAGE_WIDTHS.W_1000}
                  ratio={`${get(imageMobileDimensions, 'width')}:${get(
                    imageMobileDimensions,
                    'height'
                  )}`}
                />
              </Small>
            )}
            {hasDesktopImage && (
              <MediumUp>
                <Image
                  src={get(imageDesktop, ['file', 'url'])}
                  alt={get(imageDesktop, 'title')}
                  width={IMAGE_WIDTHS.W_2000}
                  ratio={`${get(imageDesktopDimensions, 'width')}:${get(
                    imageDesktopDimensions,
                    'height'
                  )}`}
                />
              </MediumUp>
            )}
          </Cell>
        </Grid>
      </Container>
      <style jsx global>
        {`
          .SustainabilityPageCopy .SustainabilityPageCopy__grid {
            flex-direction: row;
          }

          @media ${smallUp} {
            .SustainabilityPageCopy .SustainabilityPageCopy__grid {
              justify-content: center;
            }
          }

          @media ${largeUp} {
            .SustainabilityPageCopy .SustainabilityPageCopy__grid {
              justify-content: flex-end;
            }
          }
        `}
      </style>
    </div>
  );
};

SustainabilityPageCopy.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.shape({}).isRequired,
    imageDesktop: PropTypes.shape({
      title: PropTypes.string,
      file: PropTypes.shape({
        url: PropTypes.string,
        details: PropTypes.shape({
          image: PropTypes.shape({
            height: PropTypes.string,
            width: PropTypes.string,
          }),
        }),
      }),
    }),
    imageMobile: PropTypes.shape({
      title: PropTypes.string,
      file: PropTypes.shape({
        url: PropTypes.string,
        details: PropTypes.shape({
          image: PropTypes.shape({
            height: PropTypes.string,
            width: PropTypes.string,
          }),
        }),
      }),
    }),
  }).isRequired,
};

export default SustainabilityPageCopy;
